import { styled } from "styled-components";

import { ActionButtonItem, CheckIcon, PlusIcon, Spinner } from "common/components";
import { useTranslate } from "common/utilities/useTranslate";
import { useTopicFollowing } from "domains/topic/components/useTopicFollowing";

const StyledFollowIcon = styled(PlusIcon)``;

const StyledUnfollowIcon = styled(CheckIcon)`
  width: 12px;
  height: 12px;
`;

const StyledSpinner = styled(Spinner)`
  width: 24px;
  height: 24px;
`;

type FollowActionButtonProps = { topicId: string; topicName: string; isFollowing: boolean };

export const FollowActionButton = ({ topicId, topicName, isFollowing }: FollowActionButtonProps) => {
  const { isFollowingUpdating, toggleFollow } = useTopicFollowing({
    topicId,
    topicName,
    isFollowing,
    pageForTracking: "Topic detail",
  });

  const translate = useTranslate();

  const followIcon = isFollowingUpdating ? (
    <StyledSpinner />
  ) : isFollowing ? (
    <StyledUnfollowIcon />
  ) : (
    <StyledFollowIcon />
  );

  const label = isFollowing ? "app.topic.following" : "app.topic.follow";

  return <ActionButtonItem label={translate(label)} icon={followIcon} onClick={() => void toggleFollow()} />;
};
